export default {
  TRAVEL: "travel",
  TRAVEL_MY_TRIPS: "trips",
  DISNEYLAND: "disneyland", // legacy
  WALT_DISNEY_WORLD: "walt-disney-world", // legacy
  SEAWORLD: "seaworld", // legacy
  UNIVERSAL_HOLLYWOOD: "universal-hollywood", // legacy
  UNIVERSAL_ORLANDO: "universal-orlando", // legacy
  HOTELS: "hotels",
  CARS: "cars",
  ACTIVITIES: "activities",
  FLIGHTS: "flights",
  THEME_PARKS: "theme-parks", // legacy
  ATTRACTIONS: "attractions", // legacy
  OFFER: "offer",
  GROCERY_COUPONS: "grocery-coupons",
  SEARCH: "search",
  STORE: "store",
  LOCATION: "location",
  FAQ: "travel_faq",
  RETAILERS: "retailer",
  LEGACY_PARKS: "parks",
  EVENTS: "events",
  ACCOUNT: "account", // PD-5482
  FAVORITES: "favorites", // PD-5811
  UNSUBSCRIBE: "unsubscribe",
};
